<mat-tab-group
  mat-stretch-tabs="false"
  mat-align-tabs="start"
  animationDuration="0ms"
  [selectedIndex]="this.selectedIndex"
  (selectedIndexChange)="onTabChange($event)"
>
  <div class="layout-container">
    <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.EVENTS' | translate }}">
      <ng-template matTabContent>
        <meeting-scheduler-group-and-service [selectedToggle]="'events'"> </meeting-scheduler-group-and-service>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.GROUP' | translate }}">
      <ng-template matTabContent>
        <meeting-scheduler-group-and-service [selectedToggle]="'group'"> </meeting-scheduler-group-and-service>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ 'MEETING_SCHEDULER.MEETING_LIST.SERVICE' | translate }}">
      <ng-template matTabContent>
        <meeting-scheduler-group-and-service [selectedToggle]="'service'"> </meeting-scheduler-group-and-service>
      </ng-template>
    </mat-tab>
  </div>
</mat-tab-group>
